import React, {useId} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useTranslate} from '../hooks/LanguageProvider';

/** Explanations stay available by pointer, keyboard focus and touch. */
export default function SecurityHelp({text}: {text: string}) {
  const {translate: tr} = useTranslate();
  const id = useId();
  return <OverlayTrigger placement="auto" trigger={['hover', 'focus']} overlay={<Tooltip id={id}>{tr(text)}</Tooltip>}>
    <button type="button" className="security-help" aria-label={tr('Information')}><i className="fas fa-info-circle" aria-hidden="true"/></button>
  </OverlayTrigger>;
}
